"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCrimesInAreaAreasCrimeGetRequest$ = exports.GetCrimesInAreaAreasCrimeGetRequest$outboundSchema = exports.GetCrimesInAreaAreasCrimeGetRequest$inboundSchema = exports.GetCrimesInAreaAreasCrimeGetSecurity$ = exports.GetCrimesInAreaAreasCrimeGetSecurity$outboundSchema = exports.GetCrimesInAreaAreasCrimeGetSecurity$inboundSchema = void 0;
exports.getCrimesInAreaAreasCrimeGetSecurityToJSON = getCrimesInAreaAreasCrimeGetSecurityToJSON;
exports.getCrimesInAreaAreasCrimeGetSecurityFromJSON = getCrimesInAreaAreasCrimeGetSecurityFromJSON;
exports.getCrimesInAreaAreasCrimeGetRequestToJSON = getCrimesInAreaAreasCrimeGetRequestToJSON;
exports.getCrimesInAreaAreasCrimeGetRequestFromJSON = getCrimesInAreaAreasCrimeGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetCrimesInAreaAreasCrimeGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetCrimesInAreaAreasCrimeGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCrimesInAreaAreasCrimeGetSecurity$;
(function (GetCrimesInAreaAreasCrimeGetSecurity$) {
    /** @deprecated use `GetCrimesInAreaAreasCrimeGetSecurity$inboundSchema` instead. */
    GetCrimesInAreaAreasCrimeGetSecurity$.inboundSchema = exports.GetCrimesInAreaAreasCrimeGetSecurity$inboundSchema;
    /** @deprecated use `GetCrimesInAreaAreasCrimeGetSecurity$outboundSchema` instead. */
    GetCrimesInAreaAreasCrimeGetSecurity$.outboundSchema = exports.GetCrimesInAreaAreasCrimeGetSecurity$outboundSchema;
})(GetCrimesInAreaAreasCrimeGetSecurity$ || (exports.GetCrimesInAreaAreasCrimeGetSecurity$ = GetCrimesInAreaAreasCrimeGetSecurity$ = {}));
function getCrimesInAreaAreasCrimeGetSecurityToJSON(getCrimesInAreaAreasCrimeGetSecurity) {
    return JSON.stringify(exports.GetCrimesInAreaAreasCrimeGetSecurity$outboundSchema.parse(getCrimesInAreaAreasCrimeGetSecurity));
}
function getCrimesInAreaAreasCrimeGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCrimesInAreaAreasCrimeGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetCrimesInAreaAreasCrimeGetSecurity' from JSON`);
}
/** @internal */
exports.GetCrimesInAreaAreasCrimeGetRequest$inboundSchema = z.object({
    "filter[crime_type]": z.array(shared.CrimeType$inboundSchema).optional(),
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    sector: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[crime_type]": "filterCrimeType",
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetCrimesInAreaAreasCrimeGetRequest$outboundSchema = z.object({
    filterCrimeType: z.array(shared.CrimeType$outboundSchema).optional(),
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    sector: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterCrimeType: "filter[crime_type]",
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCrimesInAreaAreasCrimeGetRequest$;
(function (GetCrimesInAreaAreasCrimeGetRequest$) {
    /** @deprecated use `GetCrimesInAreaAreasCrimeGetRequest$inboundSchema` instead. */
    GetCrimesInAreaAreasCrimeGetRequest$.inboundSchema = exports.GetCrimesInAreaAreasCrimeGetRequest$inboundSchema;
    /** @deprecated use `GetCrimesInAreaAreasCrimeGetRequest$outboundSchema` instead. */
    GetCrimesInAreaAreasCrimeGetRequest$.outboundSchema = exports.GetCrimesInAreaAreasCrimeGetRequest$outboundSchema;
})(GetCrimesInAreaAreasCrimeGetRequest$ || (exports.GetCrimesInAreaAreasCrimeGetRequest$ = GetCrimesInAreaAreasCrimeGetRequest$ = {}));
function getCrimesInAreaAreasCrimeGetRequestToJSON(getCrimesInAreaAreasCrimeGetRequest) {
    return JSON.stringify(exports.GetCrimesInAreaAreasCrimeGetRequest$outboundSchema.parse(getCrimesInAreaAreasCrimeGetRequest));
}
function getCrimesInAreaAreasCrimeGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCrimesInAreaAreasCrimeGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetCrimesInAreaAreasCrimeGetRequest' from JSON`);
}
//# sourceMappingURL=getcrimesinareaareascrimeget.js.map